import { render, staticRenderFns } from "./headCard.vue?vue&type=template&id=70a83574&scoped=true"
import script from "./headCard.vue?vue&type=script&lang=js"
export * from "./headCard.vue?vue&type=script&lang=js"
import style0 from "./headCard.vue?vue&type=style&index=0&id=70a83574&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a83574",
  null
  
)

export default component.exports